var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHulu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 328.461",
    width: 1000,
    height: 328.461,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3067",
    y2: 21.07,
    x2: 0.98000002,
    y1: 20.07,
    x1: -0.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop3069",
    stopOpacity: 1,
    stopColor: "#2dbd9d",
    offset: 0.4471,
    style: {
      stopColor: "#2fbe9d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop3071",
    stopOpacity: 1,
    stopColor: "#72de93",
    offset: 1,
    style: {
      stopColor: "#51ce98",
      stopOpacity: 1
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient3050",
    gradientUnits: "userSpaceOnUse",
    x1: -0.02,
    y1: 20.07,
    x2: 8.437705,
    y2: -0.82375771,
    href: "#linearGradient3067"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g13",
    transform: "matrix(16.423058, 0, 0, 16.423058, -331.00001, -413.401471)",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "bevel"
    }
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g15",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g17",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g19",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g21",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g27",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g29",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g31",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g33",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g35",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g37",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g39",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g41",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g43",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g45",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g47",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g49",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g51",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g53",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g55",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g57",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g59",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g61",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g63",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g65",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g67",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 2,
    id: "g69",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 2,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g23",
    style: {
      fill: "url(#linearGradient3052)",
      stroke: "none"
    },
    transform: "translate(20.15459,25.172015)"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "none",
    d: "m 9.57,6.24 -3.1,0 C 5.9118,6.21334 5.35475,6.31245 4.84,6.53 L 4.84,0 0,0 l 0,20 4.83,0 0,-8.07 C 4.82999,11.5861 4.96727,11.2565 5.21136,11.0143 5.45545,10.7721 5.78614,10.6373 6.13,10.64 l 2.81,0 C 9.28386,10.6373 9.61455,10.7721 9.85864,11.0143 10.1027,11.2565 10.24,11.5861 10.24,11.93 l 0,8.07 4.84,0 0,-8.7 c 0,-3.66 -2.44,-5.06 -5.5,-5.06 l -0.01,0 m 46.48,0 0,8.07 c 0,0.7124 -0.5776,1.29 -1.29,1.29 l -2.82,0 C 51.5961,15.6027 51.2654,15.4679 51.0214,15.2257 50.7773,14.9835 50.64,14.6539 50.64,14.31 l 0,-8.07 -4.83,0 0,8.47 c 0,3.47 2.19,5.29 5.51,5.29 l 4.73,0 c 3,0 4.84,-2.15 4.84,-5.26 l 0,-8.5 -4.84,0 m -27.28,8.07 c 0,0.3439 -0.1373,0.6735 -0.3814,0.9157 -0.244,0.2422 -0.5747,0.377 -0.9186,0.3743 l -2.81,0 C 24.3161,15.6027 23.9854,15.4679 23.7414,15.2257 23.4973,14.9835 23.36,14.6539 23.36,14.31 l 0,-8.07 -4.83,0 0,8.47 c 0,3.47 2.22,5.29 5.47,5.29 l 4.73,0 c 3,0 4.84,-2.15 4.84,-5.26 l 0,-8.5 -4.8,0 0,8.07 m 8.52,5.69 4.84,0 0,-20 -4.84,0 0,20",
    id: "path25",
    style: {
      fill: "url(#linearGradient3050)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHulu);
export default __webpack_public_path__ + "static/media/hulu.6a4888add0b1bf82613404e0a3d93288.svg";
export { ForwardRef as ReactComponent };